<template>
    <div class="scope-cont">
        <div class="change-type" @click="change">
            {{ changeList[listactive].name }}
            <img src="@/assets/temimg15/change.png" alt="">
        </div>
        <div class="scope-head" v-show="listactive == 0">
            <div class="scope-item" v-for="(item, i) in headlist" :class="{active: activeVal == i }" :key="i">
                <div class="scope-head">
                    {{ item.name }}
                </div>
                <div class="scope-btm">
                    {{ item.value }}
					<div class="look-btn" @click="look(item)">查看</div>
                </div>
            </div>
        </div>
        <div class="lb" v-show="listactive == 0">
            <div ref="barMian" class="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
        </div>
        <div class="zr-content" v-show="listactive == 1">
			<div v-for="(item, i) in zrlist" class="zr-item" :key="i">
				<div class="zr-head">
					{{ item.value1 }}
					<div class="zr-val">{{ item.value2 }}</div>
				</div>
				<div class="zr-line">
					<div class="zr-blue-line"></div>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
import * as methods from './method.js'
export default {
    name: 'template.scope126',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
    data() {
        return {
			defaultdata: [
				{ value1: '西埔所', value2: '5', value3: '扫码次数', value4: 'chart' },
				{ value1: '铜陵所', value2: '33', value3: '扫码次数', value4: 'chart' },
				{ value1: '陈城所', value2: '16', value3: '扫码次数', value4: 'chart' },
				{ value1: '杏陈所', value2: '88', value3: '扫码次数', value4: 'chart' },
				{ value1: '西埔所', value2: '50', value3: '投诉总数', value4: 'chart' },
				{ value1: '铜陵所', value2: '20', value3: '投诉总数', value4: 'chart' },
				{ value1: '陈城所', value2: '47', value3: '投诉总数', value4: 'chart' },
				{ value1: '杏陈所', value2: '12', value3: '投诉总数', value4: 'chart' },
				{ value1: '西埔所', value2: '30', value3: '评价总数', value4: 'chart' },
				{ value1: '铜陵所', value2: '20', value3: '评价总数', value4: 'chart' },
				{ value1: '陈城所', value2: '17', value3: '评价总数', value4: 'chart' },
				{ value1: '杏陈所', value2: '32', value3: '评价总数', value4: 'chart' },
				{ value1: '已上传公示牌', value2: '6.07', value3: '', value4: 'list' },
				{ value1: '已上传风险管控清单', value2: '0.18', value3: '', value4: 'list' },
				{ value1: '本年度已包保户数', value2: '0.09', value3: '', value4: 'list' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
				{ name: '图例', key: 'value3' },
				{ name: '所属分类(chart/list)', key: 'value4' },
            ],
            activeVal: 0,
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			timer: null,
			autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
            headlist: [],
            changeList: [
                { name: '两个责任', key: 'video' },
                { name: '社会共治', key: 'list' }
            ],
            listactive: 0,
			zrlist: []
        }
    },
    watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.setval()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
        change() {
			this.$emit('titlechange', this.changeList[this.listactive].name, 5)
            if (this.listactive == 0) {
                this.listactive = 1
            } else {
                this.listactive = 0
            }
        },
        setval() {
			let chartlist = this.defaultdata.filter(item => item.value4 == 'chart')
			let xlist = this.defaultdata.filter(item => item.value4 == 'list')
			this.zrlist = xlist
            let namelist = [...new Set(chartlist.map((item) => item.value3))]
            this.headlist = namelist.map(item => {
                let total = 0
                let vlist = this.defaultdata.filter(del => del.value3 == item)
                vlist.forEach(del => {
                    total += +del.value2
                })
                return {
                    name: item,
                    value: total
                }
            })
            this.activeVal = 0
            this.DrawEcharts()
        },
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null;
			var echarts = require("echarts");
			var TmyChart = echarts.init(this.$refs.barMian);
            let vdata = this.defaultdata.filter(item => item.value3 == this.headlist[this.activeVal].name && item.value4 == 'chart')
			let mydata = vdata.map((item) => {
				let newitem = {
					name: item.value1,
					value: item.value2,
				};
				return newitem;
			});

			const xAxis = vdata.map((item) => {
				return item.value1;
			});

			const percent = (7 / xAxis.length) * 100;
			let zoom = [
				{
					id: "scope28", // 唯一的id
					filterMode: "empty",
					mayValueSpan: 7, // 显示数据的条数(默认显示10个)
					type: "slider",
					xAxisIndex: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。
					dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					backgroundColor: "transparent",
					fillerColor: "transparent",
					borderColor: "transparent",
					start: 0,
					end: percent,
					top: "80%",
					height: "5%",
				},
			];
			var Toption = {
				title: [
					{
						text: '',
						top: "0",
						left: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
				],
				tooltip: {
					trigger: "axis",
				},
				// legend: [
				// 	{
				// 		top: "2%",
				// 		right: 50,
				// 		itemHeight: 12, //图例的高度  文字左边那个
				// 		itemWidth: 10,
				// 		icon: "rect",
				// 		textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
				// 		data: [this.defaultdata[0].value3 || ""],
				// 	},
				// ],
				grid: {
					left: "5px",
					right: "10px",
					bottom: "0px",
					top: "15px",
					containLabel: true,
				},
				xAxis: {
					type: "category",
					boundaryGap: true,
					data: mydata.map((item) => item.name),
					axisLabel: {
						interval: 0,
						width: 50,
						overflow: 'truncate', //文字超出宽度截断，默认为...
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
							fontSize: "14",
							lineHeight: 16,
						},
					},
					axisLine: {
						lineStyle: {
							// X 轴颜色配置
							color: "#4792e9",
						},
					},
					axisTick: {
						show: false,
					},
				},
				yAxis: {
					type: "value",

					splitNumber: 4,
					axisLabel: {
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
						},
					},
					axisLine: {
						show: false,
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
				},
				series: [
					{
						name: vdata[0].value3 || "",
						type: "bar",
						smooth: true,
						stack: "Total",
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0,
											color: "#00e3e2", // 0% 处的颜色
										},
										{
											offset: 0.8,
											color: "#00e3e2", // 0% 处的颜色
										},
										{
											offset: 1,
											color: "#02323d", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						symbolSize: 0,
						label: {
							show: false,
							position: "top",
							textStyle: {
								//设置文本样式
								color: "#0ADFDE",
							},
						},
						data: mydata,
						barWidth: 15,
						barGap: "40%",
					},
				],
				dataZoom: xAxis.length > 7 ? zoom : [],
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(() => {
				if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000);
		},
		look(item) {
			let index = this.headlist.findIndex(del => del.name == item.name)
			this.activeVal = index
			this.DrawEcharts()
		}
	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
        this.setval()
		// this.$nextTick(() => {
		// this.DrawEcharts(); //需要刷新的数据
		// });
	},
}
</script>

<style scoped lang="scss">
.scope-cont {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    position: relative;
	.change-type {
        position: absolute;
        right: 0px;
        top: -28px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #60A0FF;
        line-height: 15px;
        display: flex;
        align-items: center;
        margin: 0 21px 0 auto;
        cursor: pointer;
        img {
            width: 15px;
            height: 12px;
            margin-left: 8px;
        }
    }
}
.lb {
	width: 435px;
	height: 177px;
	display: flex;
	position: relative;
	overflow: hidden;
}

.barMian {
	width: 100%;
	height: 100%;
}
.scope-head {
    display: flex;
    align-items: center;
	column-gap: 32px;
	.scope-item {
		position: relative;
		opacity: .65;
		&.active {
			opacity: 1;
		}
		& + .scope-item::after {
			content: "";
			position: absolute;
			left: -15px;
			top: 9px;
			height: 30px;
			width: 1px;
			background: #FFFFFF;
		}
	}
    .scope-head {
        width: 123px;
        height: 21px;
        background: url(@/assets/temimg15/view-head.png) no-repeat;
        background-size: 100% 100%;
        padding-left: 22px;
        box-sizing: border-box;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 21px;
    }
    .scope-btm {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #F5F9FF;
        line-height: 16px;
        margin: 14px 0 12px 24px;
		display: flex;
		align-items: center;
    }
	.look-btn {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 14px;
		color: #2687EB;
		line-height: 14px;
		margin-left: auto;
		cursor: pointer;
	}
}
.zr-content {

}
.zr-head {
	display: flex;
	align-items: center;
	font-family: Source Han Sans CN;
	font-weight: 400;
	font-size: 14px;
	color: #979AA1;
	line-height: 30px;
	.zr-val {
		font-family: Benmo Ziyu;
		color: #DBF4FF;
		margin: 0 8px 0 auto;
	}
}
.zr-line {
	width: 415px;
	margin: 16px auto;
	height: 15px;
	background: rgba(74, 126, 205, .2);
	position: relative;
	&::after {
		content: "";
		width: 4px;
		height: 15px;
		background: #0975FA;
		position: absolute;
		top: 0;
		left: -8px;
	}
	&::before {
		content: "";
		width: 4px;
		height: 15px;
		background: #0975FA;
		position: absolute;
		top: 0;
		right: -8px;
	}
	.zr-blue-line {
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		width: 219px;
		background: #0979F5;
		&::after {
			content: "";
			position: absolute;
			right: -2px;
			top: 0;
			width: 2px;
			height: 15px;
			background: #B8D6FD;
		}
	}
}
</style>